import { titleize } from 'inflected';
import { MergeFieldData } from '../model';
import { getMergeSchema } from '../utilities';

export const MergeField = (options?: Partial<MergeFieldData>): PropertyDecorator => {
    return (target: any, propertyKey: string | symbol): void => {

        const meta = getMergeSchema(target);

        let displayName = titleize(propertyKey as string)
        if ((propertyKey as string).toLowerCase().endsWith('id')) {
            displayName = `${displayName} ID`;
        }

        const field = {
            name: propertyKey,
            displayName: displayName,
            hidden: (propertyKey as string).startsWith('_'),
            ...options
        } as MergeFieldData;

        meta.fields.push(field);

    };
};